import types from './types';

const getUI = state => (state && state.ui) || {};

const getMiniCartPopover = state => getUI(state).miniCartPopover;
const getMiniCartPopoverStatus = state => getMiniCartPopover(state).isOpened;
const getMiniCartForcedMessages = state => getUI(state).miniCartForcedMessages || [];
const getWindowSize = state => getUI(state).windowSize;
const getModalValue = state => getUI(state)[types.OPEN_MODAL];
const getLang = state => getUI(state).lang || '';
const getFiltersMenuDisplayed = state => getUI(state).filtersMenuDisplayed;
const getLinkableTab = state => getUI(state).linkableTab;
const getDialog = state => getUI(state).dialog || {};
const getDialogContent = state => getDialog(state).content;
const getDialogIframeUrl = state => getDialog(state).iframeUrl;
const getIframeRedirectOnClose = state => getDialog(state).iframeRedirectOnClose;
const getDialogState = (state, name) => getDialog(state).opened === name;
const getDialogName = state => getDialog(state).opened;
const getScrollTop = state => getUI(state).scrollTop;
const getAccountNav = state => getUI(state).accountNav || {};
const getAccountNavigation = state => getAccountNav(state).tree || [];
const getAccountNavigationActive = state => getAccountNav(state).active || {};
const getTabName = state => getUI(state).tabName || '';
const getFlyDownState = state => getUI(state).needsFlyDownEffect;
const preventClick = state => getUI(state).preventClick;
const getLoginPopoverOpened = state => getUI(state).loginPopoverOpened;
const isAccordionOpened = (state, name) =>
    !!getUI(state).accordionOpened.find(i => i.name === name);
const isAccordionGroupOpened = (state, groupName) =>
    !!getUI(state).accordionOpened.find(i => i.group === groupName);
const getNavigationState = state => getUI(state).isNavigationOpened;
const getMyAccountNavigationState = state => getUI(state).isMyAccountNavigationOpened;
const getVariantSelectStatus = state => getUI(state).openVariantSelectStatus || false;
const getVisibleElements = state => getUI(state).visibleElements || [];
const getHeaderScrolled = state => getUI(state).headerScrolled || false;
const getPageScrolledDown = state => getUI(state).pageScrolledDown || false;
const getHoveredMiniCartProduct = state => getMiniCartPopover(state).hoveredMiniCartProduct || '';
const getFacetSearchValue = state => getUI(state).facetSearchValue;
const isFacetFilterHidden = (state, name) =>
    !name.toLowerCase().includes(getFacetSearchValue(state).toLowerCase());
const getOpenReviewsWrapper = state => getUI(state).openReviewsWrapper;
const getScrollGroupAnchor = state => getUI(state).scrollGroupAnchor || '';
const getPlpViewTypes = state => getUI(state).plpViewType || {};
const getPlpViewType = (state, _id) => {
    const id = _id || 'default';
    return getPlpViewTypes(state)[id];
};
const getPageViewType = state => getUI(state).pageViewType;
const getContentItemsAmount = state => getUI(state).contentItemsAmount;
const isStickyBarsExpanded = state => getUI(state).isStickyBarExpanded || {};
const isStickyBarExpanded = (state, id) => {
    return isStickyBarsExpanded(state)[id];
};
const getCustomHandleClose = state => getUI(state).customHandleClose;
const isTopBrandsShown = state => getUI(state).isTopBrandsShown;
const isNewsletterDisclaimerShown = state => getUI(state).isNewsletterDisclaimerShown;
const getElementsToRefresh = state => getUI(state).elementsToRefresh || [];
const shouldUpdateElement = (state, id) => getElementsToRefresh(state).includes(id);
const getHoveredGWPProduct = state => getUI(state).hoveredGWPProduct;
const isBVInitialized = state => getUI(state).bvInitialized;
const getActiveAlphabetFilters = state => getUI(state).activeAlphabetFilters || {};
const getOpenStoreInfo = state => getUI(state).storeInfoPopupOpened;
const getContentViewChanged = state => getUI(state).contentViewChanged;
const getExpandedAccordionGroup = (state, groupName) =>
    getUI(state).expandedAccordionGroups[groupName] || {};
const getExpandedAccordionGroupItem = (state, groupName, id) =>
    getExpandedAccordionGroup(state, groupName)[id] || false;
const getConnectedAndShow = state => getUI(state).connectedAndShow || {};
const getConnectedAndShowById = (state, id) => getConnectedAndShow(state)[id];
const getFirstConnectedAndShowItem = state =>
    Object.keys(getConnectedAndShow(state)).find(
        id => id !== 'container' && getConnectedAndShowById(state, id),
    );

const getConnectedAndShowContainer = state => getConnectedAndShow(state).container;
const getContainerByName = (state, name) => getConnectedAndShowContainer(state)[name] || {};
const shouldShowContainer = (state, name) =>
    Object.values(getContainerByName(state, name)).some(el => !!el);

const getRealTimeStock = state => getUI(state).realTimeStock || {};
const getForceOpen = state => getRealTimeStock(state).forceClick;
const getselectedQuantity = state => getRealTimeStock(state).productQuantity;
const getCollapsibleItems = (state, itemsUid) => getUI(state).collapsibleItems[itemsUid] || {};
const getCollapsibleItemsToShow = (state, itemsUid) =>
    getCollapsibleItems(state, itemsUid).minItemsToShow || 0;
const getRegisteredIframes = state => getUI(state).registeredIframes || [];
const getClearPincode = state => getUI(state).clearPincode;
const getOpenedLightPopup = state => getUI(state).lightPopup || null;

export default {
    getMiniCartPopover,
    getMiniCartPopoverStatus,
    getMiniCartForcedMessages,
    getWindowSize,
    getFacetSearchValue,
    getOpenStoreInfo,
    getModalValue,
    getLang,
    getFiltersMenuDisplayed,
    getTabName,
    getLinkableTab,
    getDialog,
    getDialogState,
    getDialogName,
    getScrollTop,
    getDialogContent,
    getDialogIframeUrl,
    getIframeRedirectOnClose,
    getAccountNavigation,
    getAccountNavigationActive,
    getNavigationState,
    getMyAccountNavigationState,
    getFlyDownState,
    isAccordionOpened,
    isAccordionGroupOpened,
    getLoginPopoverOpened,
    preventClick,
    getVariantSelectStatus,
    getVisibleElements,
    getHeaderScrolled,
    getPageScrolledDown,
    getHoveredMiniCartProduct,
    isFacetFilterHidden,
    getOpenReviewsWrapper,
    getScrollGroupAnchor,
    getPlpViewTypes,
    getPlpViewType,
    getPageViewType,
    getContentItemsAmount,
    isStickyBarExpanded,
    getCustomHandleClose,
    isTopBrandsShown,
    isNewsletterDisclaimerShown,
    shouldUpdateElement,
    getHoveredGWPProduct,
    getActiveAlphabetFilters,
    isBVInitialized,
    getContentViewChanged,
    getExpandedAccordionGroup,
    getExpandedAccordionGroupItem,
    getConnectedAndShow,
    getConnectedAndShowById,
    getFirstConnectedAndShowItem,
    shouldShowContainer,
    getForceOpen,
    getselectedQuantity,
    getCollapsibleItemsToShow,
    getRegisteredIframes,
    getClearPincode,
    getOpenedLightPopup,
};
